(() => {
  const checkoutSelector = '[name="checkout"], [name="goto_pp"], [name="goto_gc"]';
  const alertMessage = "You must agree with the terms and conditions of sales to check out.";

  function validateTerms(form) {
    if (!form?.hasAttribute("data-requires-terms")) {
      return true;
    }

    const checkbox = form.querySelector("[data-terms-checkbox]");

    if (checkbox?.checked) {
      return true;
    }

    window.alert(alertMessage);
    checkbox?.focus();
    return false;
  }

  document.addEventListener(
    "click",
    (event) => {
      const checkoutButton = event.target.closest?.(checkoutSelector);

      if (!checkoutButton || validateTerms(checkoutButton.form || checkoutButton.closest("form"))) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  document.addEventListener(
    "submit",
    (event) => {
      const checkoutButton = event.submitter;

      if (!checkoutButton?.matches(checkoutSelector) || validateTerms(event.target)) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );
})();

(() => {
  // The delivery app rewrites the "_instoreAppId" line item property (with a fresh
  // timestamp) on every page load, which changes every line item key after the page
  // was rendered. Line keys baked into the HTML are therefore stale by the time the
  // shopper clicks, and /cart/change.js answers "no valid id or line parameter".
  const originalFetch = window.fetch;

  const cartUrl = () => `${window.Shopify?.routes?.root || "/"}cart.js`;

  async function currentLineKey(staleKey) {
    const cart = await originalFetch(cartUrl(), { headers: { Accept: "application/json" } }).then((response) =>
      response.json()
    );

    if (cart.items.some((item) => item.key === staleKey)) {
      return staleKey;
    }

    const variantId = staleKey.split(":")[0];
    const candidates = cart.items.filter((item) => String(item.id) === variantId);

    if (candidates.length === 0) {
      return staleKey;
    }

    if (candidates.length === 1) {
      return candidates[0].key;
    }

    const renderedKeys = [
      ...new Set([...document.querySelectorAll("[data-line-key]")].map((element) => element.getAttribute("data-line-key")))
    ].filter((key) => key.startsWith(`${variantId}:`));

    return (candidates[renderedKeys.indexOf(staleKey)] || candidates[0]).key;
  }

  window.fetch = async function (resource, options) {
    const url = typeof resource === "string" ? resource : resource?.url;

    if (!url?.includes("/cart/change.js") || typeof options?.body !== "string") {
      return originalFetch.apply(this, arguments);
    }

    let payload;

    try {
      payload = JSON.parse(options.body);
    } catch {
      return originalFetch.apply(this, arguments);
    }

    if (typeof payload.id !== "string" || !payload.id.includes(":")) {
      return originalFetch.apply(this, arguments);
    }

    let lineKey;

    try {
      lineKey = await currentLineKey(payload.id);
    } catch {
      return originalFetch.apply(this, arguments);
    }

    if (lineKey === payload.id) {
      return originalFetch.apply(this, arguments);
    }

    return originalFetch.call(this, resource, {
      ...options,
      body: JSON.stringify({ ...payload, id: lineKey })
    });
  };
})();
